// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FACET_LOCATION = "Lokalita";
export const BZ2_SHOW_PLACES_RADIUS = "Zobrazuj i okol\u00ed 25km\n";
export const LOCATION_FACET_COUNTY = "okres";
